"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
var skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var lodash_1 = require("lodash");
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var noop_1 = require("rxjs/util/noop");
var currency_control_state_1 = require("../../currency-control.state");
var utilities_1 = require("../../utilities");
var SisAmountComponent = /** @class */ (function () {
    function SisAmountComponent(store, formattingService, cd) {
        this.store = store;
        this.formattingService = formattingService;
        this.cd = cd;
        this.amountAsString = '';
        this.logger = utilities_1.createLogger('sis-amount');
        this.blur = new Subject_1.Subject();
        this.destroy = new Subject_1.Subject();
        this.recalculateHint = new BehaviorSubject_1.BehaviorSubject(undefined);
    }
    Object.defineProperty(SisAmountComponent.prototype, "currencyControlState", {
        set: function (value) {
            this._currencyControlState = value;
        },
        enumerable: true,
        configurable: true
    });
    SisAmountComponent.prototype.onBlur = function () {
        this.blur.next();
    };
    SisAmountComponent.prototype.setAmountString = function (amount) {
        this.amountAsString = amount;
        this.recalculateHint.next(undefined);
    };
    SisAmountComponent.prototype.handleKeyPress = function (event) {
        if (!/[0-9.,]/.test(event.key)) {
            event.preventDefault();
        }
    };
    SisAmountComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.logger = utilities_1.createLogger('sis-amount:' + this.id);
        var fractionDigits$ = this.formattingService.getCurrentLocale().pipe(operators_1.map(function (locale) { return locale.numberFormat.fractionDigits; }), operators_1.first(), operators_1.publishReplay(1), operators_1.refCount());
        this.blur
            .pipe(operators_1.switchMapTo(fractionDigits$), operators_1.switchMap(function (fractionDigits) {
            return _this.formattingService
                .parseNumber(_this.amountAsString)
                .pipe(operators_1.first(), operators_1.map(function (amount) { return utilities_1.round(amount, fractionDigits); }), operators_1.switchMap(function (amount) {
                _this._currencyControlState.updateAmount(amount);
                return _this.formatAmount(amount);
            }), operators_1.first(), operators_1.tap(function (amountAsString) {
                _this.setAmountString(amountAsString);
                _this.cd.detectChanges();
            }));
        }), operators_1.takeUntil(this.destroy))
            .subscribe(noop_1.noop, function (e) { return _this.logger.error(e); });
        this._currencyControlState
            .getMoney()
            .pipe(operators_1.switchMap(function (money) { return _this.formatAmount(money.amount); }), operators_1.tap(function (amountAsString) {
            _this.setAmountString(amountAsString);
            _this.cd.detectChanges();
        }), operators_1.takeUntil(this.destroy))
            .subscribe(noop_1.noop, function (e) { return _this.logger.error(e); });
        this._currencyControlState
            .getMoney()
            .pipe(operators_1.map(function (m) { return m.currencyId; }), operators_1.filter(skynet_store_utilities_1.notNil), operators_1.switchMap(function (currencyId) {
            return skynet_store_currencies_api_1.currencyStoreManager.selectOne(_this.store, currencyId);
        }), utilities_1.simpleDebug(this.logger, 'currency$ %O'), operators_1.takeUntil(this.destroy))
            .subscribe(function (currency) {
            _this.currencySymbol = currency.symbol;
            _this.cd.detectChanges();
        }, function (e) { return _this.logger.error(e); });
        combineLatest_1.combineLatest(skynet_store_currencies_api_1.getDefaultCurrency(this.store), this._currencyControlState.getAccounting(), this.recalculateHint)
            .pipe(operators_1.switchMap(function (_a) {
            var defaultCurrency = _a[0], accounting = _a[1];
            if (_this.amountAsString === '' ||
                lodash_1.isNil(accounting.rateToDefault) ||
                accounting.originalMoney.currencyId ===
                    defaultCurrency.id) {
                _this.rateHint = '';
                _this.cd.detectChanges();
                return of_1.of();
            }
            return _this.formattingService
                .parseNumber(_this.amountAsString)
                .pipe(operators_1.switchMap(function (parsed) {
                if (skynet_store_utilities_1.notNil(parsed)) {
                    return _this.formattingService.formatNumber(accounting.rateToDefault * parsed);
                }
                else {
                    return of_1.of(undefined);
                }
            }), operators_1.tap(function (formatted) {
                _this.rateHint = skynet_store_utilities_1.notNil(formatted)
                    ? "= " + defaultCurrency.symbol + " " + formatted
                    : '';
                _this.cd.detectChanges();
            }));
        }), utilities_1.simpleDebug(this.logger, 'rateHint %O'))
            .subscribe(noop_1.noop, function (e) { return _this.logger.error(e); });
    };
    SisAmountComponent.prototype.ngOnDestroy = function () {
        this.destroy.next();
        this.destroy.complete();
    };
    SisAmountComponent.prototype.formatAmount = function (inputAmount) {
        if (lodash_1.isNil(inputAmount) || isNaN(inputAmount)) {
            return of_1.of('');
        }
        return this.formattingService.formatNumber(inputAmount);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisAmountComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisAmountComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisAmountComponent.prototype, "hint", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", currency_control_state_1.CurrencyControlState),
        __metadata("design:paramtypes", [currency_control_state_1.CurrencyControlState])
    ], SisAmountComponent.prototype, "currencyControlState", null);
    SisAmountComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-amount',
            template: require('./sis-amount.component.html'),
            styles: [require('./sis-amount.component.css')],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        }),
        __metadata("design:paramtypes", [store_1.Store,
            idm_frontend_shared_1.FormattingService,
            core_1.ChangeDetectorRef])
    ], SisAmountComponent);
    return SisAmountComponent;
}());
exports.SisAmountComponent = SisAmountComponent;
//# sourceMappingURL=sis-amount.component.js.map